export default ($options) => Object.assign({
  enableEvents: true
}, $options)